import { render, staticRenderFns } from "./tencentadgroups.vue?vue&type=template&id=343e3fe8&"
import script from "./tencentadgroups.vue?vue&type=script&lang=js&"
export * from "./tencentadgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports